import script from "./welcome1.vue?vue&type=script&setup=true&lang=js"
export * from "./welcome1.vue?vue&type=script&setup=true&lang=js"

import "./welcome1.vue?vue&type=style&index=0&id=0747f808&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0747f808"]])

export default __exports__